export enum SnippetProfileListType {
    DistributionList = 'distributionList'
}
